define("SuiteDB.SDBQuoteImprovements.Modal.View", [
  "suitedb_sdbquoteimprovements_modal.tpl",
  "CCAW.OrderTerms.Consent.View",
], function (suitedb_sdbquoteimprovements_modal_tpl, ConsentView) {
  "use strict";

  return Backbone.View.extend({
    template: suitedb_sdbquoteimprovements_modal_tpl,

    events: {
      'click [data-action="review-quote-and-order"]': "handleRedirect",
    },
    initialize: function initialize(options) {
      this.container = options.container;
      this.options = options;
      this.model = options.model;
      this.page_header = "Review and Place Order";
    },
    handleRedirect: function handleRedirect(e) {
      e.preventDefault();
      try {
        var locationObject = this.options.nextLocation;
        var locationsModel = this.options.model;
        if (locationObject) {
          locationsModel.setCookie({
            shoppingExperience: "instore",
            location: locationObject,
          });
        } else {
          locationsModel.removeLocation();
          locationsModel.setCookie({ shoppingExperience: "online" });
        }
        Backbone.history.navigate(this.options.reviewQuoteURL, {
          trigger: true,
        });

        var container = this.container;
        var layout = container.getComponent("Layout");
        layout.registerView("CCAW.OrderTerms.Consent.View", function () {
          return new ConsentView({
            container: container,
            showOrderTerms: true,
          });
        });
      } catch (error) {
        console.error("error in handleRedirect", error);
      }
    },
    getContext: function getContext() {
      return {};
    },
  });
});
